import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const userGetProfile = async () => {
  try {
    const response = await APIs.get(`/get_user`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editUser = async (payload) => {
  try {
    const response = await APIs.patch(`/update_profile`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editUserDetails = async (payload) => {
  try {
    const response = await APIs.patch(`/edit_user`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editUserAddress = async (payload) => {
  try {
    const response = await APIs.patch(`/edit_user`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editUserPassword = async (payload) => {
  try {
    const response = await APIs.patch(`/edit_user_password`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const profileUserService = {
  editUser,
  userGetProfile,
  editUserPassword,
  editUserDetails,
  editUserAddress,
};

export default profileUserService;
